// ParameterContext.tsx
import React, { createContext, useContext, useState } from "react";

// Define the shape of the context
interface ParameterContextType {
  scenario: string[];
  parameter: string[];
  time: string;
  calcDiff: boolean; 
  transparency?: number;
  plotSelectedTime?: string;
  spatialAggregationName?: string;
  setCalcDiff: React.Dispatch<React.SetStateAction<boolean>>;
  setScenario: React.Dispatch<React.SetStateAction<string[]>>;
  setParameter: React.Dispatch<React.SetStateAction<string[]>>;
  setTime: React.Dispatch<React.SetStateAction<string>>;
  //transparency is a number between 0 and 100%, where 100 is fully transparent and 0 is fully opaque
  setTransparency?: React.Dispatch<React.SetStateAction<number>>;
  setPlotSelectedTime?: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSpatialAggregationName?: React.Dispatch<React.SetStateAction<string>>;
 }

// Create the context with default values
const ParameterContext = createContext<ParameterContextType | undefined>(undefined);

export const useParameterContext = () => {
  const context = useContext(ParameterContext);
  if (!context) {
    throw new Error("useParameterContext must be used within a ParameterProvider");
  }
  return context;
};

export const ParameterProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [scenario, setScenario] = useState<string[]>([]);
  const [parameter, setParameter] = useState<string[]>([]);
  const [time, setTime] = useState<string>("");
  const [calcDiff, setCalcDiff] = useState<boolean>(false);
  const [transparency, setTransparency] = useState<number>(0); // Default to fully opaque
  const [plotSelectedTime, setPlotSelectedTime] = useState<string>(); 
  const [spatialAggregationName, setSpatialAggregationName] = useState<string>("");

  return (
    <ParameterContext.Provider value={{scenario,parameter,time,setScenario,setParameter,setTime,
      calcDiff,setCalcDiff, transparency, setTransparency,plotSelectedTime, setPlotSelectedTime, 
      spatialAggregationName, setSpatialAggregationName}}>
      {children}
    </ParameterContext.Provider>
  );
};

export {};